<template>
  <div class="promote-section">
    <div class="ly--outer--container noPadding">
      <div class="promote-section__container">
        <!-- Main content banner -->
        <div class="promote-section__banner">
          <!-- Background decorative image -->

          <ImageWrapper
            src="/assets/images/promote-bg-decoration.png"
            alt="Background Decoration"
            class="promote-section__bg-decoration"
          />

          <div class="promote-section__content-wrapper">
            <!-- Decorative vector -->
            <div class="promote-section__vector">
              <ImageWrapper
                src="/assets/images/promote-vector.svg"
                alt="Decorative Vector"
              />
            </div>

            <!-- Logo -->
            <div class="promote-section__logo">
              <ImageWrapper
                src="/assets/images/promote-logo.png"
                alt="Nespresso Logo"
              />
            </div>

            <!-- Content -->
            <div class="promote-section__content">
              <div class="promote-section__text">
                <p
                  class="promote-section__subtitle"
                  v-html="$t('promote.subtitle')"
                ></p>
                <h2
                  class="promote-section__title"
                  v-html="$t('promote.title')"
                ></h2>
                <p
                  class="promote-section__description"
                  v-html="$t('promote.description')"
                ></p>
                <p
                  class="promote-section__date"
                  v-html="$t('promote.date')"
                ></p>
              </div>

              <!-- Machine images -->
              <div class="promote-section__machines">
                <ImageWrapper
                  src="/assets/images/promotion_slash.png"
                  alt="Promotion Slash"
                  class="promote-section__slash"
                />

                <div
                  class="promote-section__machine promote-section__machine--left"
                >
                  <ImageWrapper
                    src="/assets/images/promote-machine-1.png"
                    alt="Coffee Machine 1"
                  />
                </div>
                <div
                  class="promote-section__machine promote-section__machine--right"
                >
                  <ImageWrapper
                    src="/assets/images/promote-machine-2.png"
                    alt="Coffee Machine 2"
                  />
                </div>
              </div>

              <!-- CTA Button -->
              <div class="promote-section__cta">
                <a
                  class="promote-section__button"
                  :href="$t('promote.ctaLink')"
                  target="_blank"
                >
                  {{ $t("promote.cta") }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Background machine image -->
        <div class="promote-section__bg-machine">
          <ImageWrapper
            src="/assets/images/promo__bg2.jpg"
            alt="Coffee Machine Background"
          />
          <!-- Recipe Section -->
          <div class="promote-section__recipe">
            <div
              class="recipe-content d-flex flex-column align-items-center gap-3"
            >
              <h2
                class="recipe-title text-center text-uppercase mb-0"
                v-html="$t('recipe.title')"
              ></h2>
              <p class="recipe-description text-center mb-0">
                {{ $t("recipe.description") }}
              </p>
              <button
                class="recipe-button btn d-flex align-items-center justify-content-center"
                @click="handleViewAllRecipes"
              >
                <span class="recipe-button-text">{{
                  $t("recipe.viewAllButton")
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- receipe home popup -->
    <Popup
      :title="$t('promote.title')"
      :isVisible="isPopupVisible"
      size="large"
      @close="isPopupVisible = false"
    >
      <!-- <p v-for="n in 10" :key="n" class="col__black">
        This is some content that will eventually cause a scrollbar to appear.
        Item {{ n }}
      </p> -->
      <div
        class="col__black d-flex flex-column align-items-center gap-3 overflow-hidden"
      >
        <p
          class="section-title fz-Nesspresso text-center text-uppercase fz-40 fw-bold"
          v-html="$t('recipe.title')"
        ></p>
        <p class="fz-Nesspresso text-center max-w-566 fz-16 fw-light">
          {{ $t("recipe.description") }}
        </p>

        <!-- Button Tab Test Section -->
        <div class="button-tab-test w-full">
          <div class="d-flex gap-3 justify-content-center flex-wrap">
            <ButtonTab
              :text="$t('recipe.tabs.essenzaMini')"
              :value="'essenzaMini'"
              :is-selected="selectedTab === 'essenzaMini'"
              @tab-click="handleTabClick"
            />
            <ButtonTab
              :text="$t('recipe.tabs.vertuoPop')"
              :value="'vertuoPop'"
              :is-selected="selectedTab === 'vertuoPop'"
              @tab-click="handleTabClick"
            />
          </div>
          <!-- <p class="text-center mt-2">Selected: {{ selectedTab }}</p> -->

          <!-- Selected Products Grid -->
          <div class="overflow-hidden relative">
            <ImageWrapper
              src="/assets/images/recipe_stroke_bg.png"
              alt=""
              class="selected-products__bg"
            />
            <div class="selected-products relative">
              <div class="row g-3 selected-products__row">
                <div
                  v-for="(product, index) in selectedProducts"
                  :key="product.name + index"
                  class="col-lg-3 col-md-4 col-sm-6 col-12 cursor-pointer"
                  @click="handleRecipeClick(product)"
                >
                  <div class="recipe-product-card">
                    <div class="recipe-product-image">
                      <ImageWrapper
                        :src="product.imagePath"
                        :alt="product.name"
                        class="img-fluid"
                      />
                    </div>
                    <h5 class="recipe-product-name text-center mt-2">
                      {{ product.name }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>

    <!-- receipe detail popup -->
    <RecipeDetailPopup
      :isVisible="isRecipeDetailPopupVisible"
      :selectedRecipe="selectedRecipe"
      :selectedTab="selectedTab"
      @close="isRecipeDetailPopupVisible = false"
    />
  </div>
</template>

<script>
import Popup from "../molecules/Popup.vue";
import RecipeHomePopup from "../organisms/RecipeHomePopup.vue";
import ButtonTab from "../atoms/ButtonTab.vue";
import RecipeDetailPopup from "../organisms/RecipeDetailPopup.vue";
import ImageWrapper from "../atoms/ImageWrapper.vue";

export default {
  name: "PromoteSection",
  components: {
    Popup,
    RecipeHomePopup,
    ButtonTab,
    RecipeDetailPopup,
    ImageWrapper,
  },
  methods: {
    /**
     * Handle view all recipes button click
     * Navigates to recipes page or triggers recipe viewing action
     */
    handleViewAllRecipes() {
      this.isPopupVisible = true;
    },

    /**
     * Handle discover offer button click
     * Scrolls to the next section or triggers promotional action
     */
    handleDiscoverOffer() {
      // Emit event to parent component or handle navigation
      this.$emit("discover-offer");

      // Optional: scroll to next section
      const nextSection = document.querySelector(".next-section");
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: "smooth" });
      }
    },

    /**
     * Handle tab click event
     * @param {String} tabValue - The value of the clicked tab
     */
    handleTabClick(tabValue) {
      this.selectedTab = tabValue;
    },

    /**
     * Handle recipe click event
     * Closes the recipe home popup, saves the selected product, and shows recipe detail popup
     * @param {Object} product - The selected product object containing recipe information
     */
    handleRecipeClick(product) {
      // 1. Close recipe home popup
      // this.isPopupVisible = false;

      // 2. Save selected product
      this.selectedRecipe = product;

      // 3. Show recipe detail popup with selected recipe info
      this.isRecipeDetailPopupVisible = true;

      // Log the selected recipe as JSON string for debugging
      console.log("Selected Recipe JSON:", JSON.stringify(product, null, 2));
    },
  },
  data() {
    return {
      isPopupVisible: false,
      isRecipeDetailPopupVisible: false,
      selectedTab: "essenzaMini", // Default selected tab
      selectedRecipe: null, // Store the selected recipe data
    };
  },
  computed: {
    /**
     * Get selected products based on the active tab
     * @returns {Array} Array of product objects for the selected tab
     */
    selectedProducts() {
      const recipeData = this.$t("recipe");

      console.log("selectedProducts:", this.selectedTab, { recipeData });
      if (recipeData && recipeData.products) {
        return recipeData.products[this.selectedTab] || [];
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .promote-section {
    position: relative;
    height: rem(571);
    overflow: hidden;

    &__container {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
    }

    &__bg-machine {
      // position: absolute;
      // bottom: 0;
      // left: 50%;
      // transform: translateX(-50%);
      // width: 100%;
      // height: 100%;
      position: relative;
      z-index: 1;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        max-width: none;
        object-fit: cover;
      }
    }

    &__banner {
      width: rem(491);
      position: relative;
      display: flex;
      justify-content: center;
      padding: rem(32) rem(40);
    }

    &__content-wrapper {
      position: relative;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__bg-decoration {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__vector {
      position: absolute;
      left: 50%;
      top: 35.48%;
      transform: translateX(-50%);
      width: rem(374.827);
      height: rem(154.774);
      transform: translateX(-50%) rotate(333.843deg);

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &__logo {
      width: rem(42);
      height: rem(42);
      margin-bottom: rem(16);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: rem(32);
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: rem(16);
      text-align: center;
      color: color(white);
      width: 100%;
    }

    &__subtitle {
      font-weight: 700;
      font-size: rem(16);
      line-height: normal;
      letter-spacing: rem(1.6);
      margin: 0;
    }

    &__title {
      font-weight: 700;
      font-size: rem(30);
      line-height: normal;
      margin: 0;
    }

    &__description {
      font-weight: 600;
      font-size: rem(16);
      line-height: 1.2;
      margin: 0;
    }

    &__date {
      font-weight: 700;
      font-size: rem(20);
      line-height: normal;
      margin: 0;
    }

    &__machines {
      position: relative;
      width: rem(277);
      height: rem(154);
    }

    &__machine {
      position: absolute;
      bottom: rem(-23.71);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &--left {
        left: rem(-0.21);
        width: rem(140.251);
        height: rem(184.879);
      }

      &--right {
        left: rem(157.41);
        width: rem(119.797);
        height: rem(178.415);
      }
    }

    &__cta {
    }

    &__button {
      background: color(white);
      box-shadow: 4px 4px 20px 0px rgba(158, 102, 102, 0.1);
      width: rem(194);
      height: rem(42);
      border: none;
      padding: 0.6875rem 2rem;

      font-weight: 700;
      font-size: rem(16);
      letter-spacing: rem(1.6);
      color: color(uniformBlue);
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(rem(-2));
        box-shadow: 4px 6px 25px 0px rgba(158, 102, 102, 0.15);
      }

      &:active {
        transform: translateY(0);
      }
    }

    // Responsive design
    @include media-breakpoint-down(lg) {
      height: auto;
      // min-height: rem(571);

      &__container {
        display: flex;
        flex-direction: column;
      }

      &__bg-machine {
        position: relative;
        width: 100%;
        flex: 1;
        overflow: hidden;
      }

      &__banner {
        position: relative;
        width: 100%;
      }

      // &__content {
      //   position: relative;
      //   left: 50%;
      //   top: rem(50);
      //   transform: translateX(-50%);
      //   width: 90%;
      //   max-width: rem(467);
      // }
    }

    &__slash {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 130%;
      height: auto;
    }

    @include media-breakpoint-down(md) {
      &__banner {
        min-height: rem(450);
      }

      &__content {
        width: 95%;
        gap: rem(24);
      }

      &__text {
        gap: rem(12);
      }

      &__subtitle {
        font-size: rem(14);
        letter-spacing: rem(1.4);
      }

      &__title {
        font-size: rem(24);
      }

      &__description {
        font-size: rem(14);
      }

      &__date {
        font-size: rem(16);
      }

      &__machines {
        width: rem(220);
        height: rem(120);
      }

      &__machine {
        &--left {
          width: rem(110);
          height: rem(145);
        }

        &--right {
          width: rem(95);
          height: rem(140);
          left: rem(125);
        }
      }

      &__button {
        width: rem(160);
        height: rem(38);
        font-size: rem(14);
        letter-spacing: rem(1.4);
      }
    }

    // Recipe Section Styles
    &__recipe {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .recipe-content {
        padding: rem(32);
      }

      .recipe-title {
        font-weight: 700;
        font-size: rem(40);
        line-height: 1.3;
        color: color(black);
        text-transform: uppercase;
        max-width: rem(700);

        span {
          display: inline-block;
        }
      }

      .recipe-popup-title {
        font-weight: 700;
        font-size: rem(40);
        line-height: normal;
        color: color(black);
        text-transform: uppercase;
      }

      .recipe-description {
        font-weight: 400;
        font-size: rem(16);
        line-height: 1.2;
        color: color(black);
        letter-spacing: rem(0.8);
        max-width: rem(500);
      }

      .recipe-button {
        background: color(white);
        // border: rem(2) solid color(uniformBlue);
        border: none;
        height: rem(42);
        padding: rem(11) rem(32);
        cursor: pointer;
        transition: all 0.3s ease;

        .recipe-button-text {
          font-weight: 700;
          font-size: rem(16);
          line-height: 1;
          color: color(uniformBlue);
          letter-spacing: rem(1.6);
          text-transform: uppercase;
        }

        // &:hover {
        //   background: color(uniformBlue);
        //   transform: translateY(rem(-2));
        //   box-shadow: 0 rem(4) rem(16) rgba(63, 74, 117, 0.3);

        //   .recipe-button-text {
        //     color: color(white);
        //   }
        // }

        // &:active {
        //   transform: translateY(0);
        // }
      }

      // Responsive design for recipe section
      @include media-breakpoint-down(lg) {
        position: relative;
        top: auto;
        left: auto;
        transform: none;
        max-width: 100%;
        padding: rem(16);
        margin: rem(24) 0;

        .recipe-content {
          padding: rem(24);
        }
      }

      @include media-breakpoint-down(md) {
        .recipe-title {
          font-size: rem(28);
        }

        .recipe-description {
          font-size: rem(14);
        }

        .recipe-button {
          // width: rem(160);
          // height: rem(38);

          .recipe-button-text {
            font-size: rem(14);
            letter-spacing: rem(1.4);
          }
        }

        .recipe-content {
          padding: rem(20);
        }
      }
    }

    // Selected Products Grid Styling
    .selected-products {
      max-width: rem(800);
      margin: 0 auto;

      &__bg {
        position: absolute;
        width: 100%;
        height: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &__row {
        align-items: flex-end;
        justify-content: space-between;
      }

      .recipe-product-card {
        display: flex;
        flex-direction: column;
        align-items: center;

        .recipe-product-image {
          max-width: rem(230);
          height: auto;
          aspect-ratio: 230 / 264;

          img {
            max-height: 100%;
            max-width: 100%;
            object-fit: contain;
          }
        }

        .recipe-product-name {
          font-weight: 600;
          font-size: rem(14);
          color: color(black);
          line-height: 1.3;
          margin: 0;
        }
      }

      // Responsive adjustments
      @include media-breakpoint-down(md) {
        .recipe-product-card {
          padding: rem(16);

          .recipe-product-image {
            height: rem(100);
          }

          .recipe-product-name {
            font-size: rem(12);
          }
        }
      }
    }
  }
}
</style>
